module.exports = __webpack_public_path__ + "static/media/layout-3.5d97e630.jpg";